<template>
    <div class="job">
        <h2>招聘职位</h2>
        <ul class="job-list" ref="jobList">
            <li @mouseenter="highlight(index)" @mouseleave="recover(index)" @click="jobShow(index)" v-for="(item,index) in jobList" :key="item.id">
                <h4>{{item.title}}<span>{{getDate(item.update_time)}}</span></h4>
                <p>{{item.account}}</p>
                <div><i class="iconfont icon-icon_arrow_right"></i></div>
            </li>
            <!--<li @mouseenter="highlight(1)" @mouseleave="recover(1)">
                <h4>高级前端开发工程师<span>2019-08-20</span></h4>
                <p>发数据库妇女们，安徽数据发数据库妇女们，安徽数据库范式美女，1你是多方面，是你的粉丝女，你马上开饭了尼玛什么，菲尼萨，方面NSA，麻烦你我们，吗，按热空气往那方面，史蒂夫纳什，麻烦吗，上翻门，年份库范式美女，1你是多方面，是你的粉丝女，你马上开饭了尼玛什么，菲尼萨，方面NSA，麻烦你我们，吗，按热空气往那方面，史蒂夫纳什，麻烦吗，上翻门，年份，</p>
                <div><i class="iconfont icon-icon_arrow_right"></i></div>
            </li>-->
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Job',
    props: {
        jobList: Array
    },
    mounted () {
    },
    methods: {
        highlight (index) {
            this.$refs.jobList.getElementsByTagName('li')[index].getElementsByTagName('div')[0].className = "highlight"
        },
        recover (index) {
            this.$refs.jobList.getElementsByTagName('li')[index].getElementsByTagName('div')[0].className = ''
        },
        jobShow (index) {
            this.$emit('job',index)
        },
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/mixins.styl'
    @import '~styles/varible.styl'
    .job 
        background: #f0f0f0
        padding: 150px 0 250px
        h2
            font-size: 42px
            max-width: 1920px
            min-width: 1440px
            margin: 0 auto 105px
            position: relative
            text-align: center
            font-weight: 600
            color: #333
            letter-spacing: 2px
            &:after
                content: ''
                position: absolute
                margin-left: -36px 
                display: block
                border-bottom: 1px solid #333
                width: 72px
                margin-top: 40px
                left: 50%
        .job-list
            width: 60%
            max-width: 1152px
            min-width: 900px
            margin: 0 auto
            li
                padding: 5% 
                padding-right: 12%
                position: relative
                background: #fff
                margin-top:  30px
                cursor: pointer
                h4
                    font-weight: 600
                    color: #333
                    font-size: 20px
                    span
                        float: right
                        color: #999
                        font-size: 14px
                        line-height: 38px
                        font-weight: 400
                p
                    height: auto
                    font-size: 14px
                    color: #666
                    margin-top: 40px
                    line-height: 24px
                    text-ellipsis()
                div
                    position: absolute
                    width: 3.6%
                    right: 0
                    top: 0
                    bottom: 0
                    background: #a0a0a0
                    color: #fff
                    i
                        position: absolute
                        left: 60%
                        top: 50%
                        margin: -0.5em 0 0 -0.6em
                .highlight
                    background: $yellow

</style>


// WEBPACK FOOTER //
// src/components/pc/JoinJob.vue